import ReactDOM from 'react-dom/client'
import { PrimeReactProvider } from 'primereact/api';
import { App } from './App.tsx'
import "primereact/resources/themes/lara-light-cyan/theme.css";
import { WithAppInsights } from './Services/AppInsightsService.tsx'


async function initializeAndRenderApp() {

  ReactDOM.createRoot(document.getElementById('root')!).render(
    <WithAppInsights>
      <PrimeReactProvider>
        <App />
      </PrimeReactProvider>
    </WithAppInsights>,
  );
}

initializeAndRenderApp();
